export default __webpack_public_path__ + "static/media/152.8b9df51b.png";